import { Instagram, Phone, Mail } from 'lucide-react';
import { PHONE, PHONE_HREF, EMAIL, INSTAGRAM, INSTAGRAM_HREF } from '../data/content';

const LINKS = [
  { label: 'About', href: '#experience' },
  { label: 'Fleet', href: '#fleet' },
  { label: 'Services', href: '#services' },
  { label: 'Vehicle Services', href: '#vehicle-services' },
  { label: 'FAQs', href: '#faq' },
  { label: 'Reserve', href: '#reserve' },
];

const Footer = ({ onNavigate }) => (
  <footer data-testid="site-footer" className="border-t border-white/5 bg-ink">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src="/images/alas-logo.png" alt="ALAS Velocity logo" className="h-16 w-16 rounded-full" loading="lazy" />
            <div>
              <span className="font-display text-2xl tracking-[0.18em] text-white">ALAS</span>
              <span className="ml-2 text-xs font-medium uppercase tracking-[0.4em] text-gold">Velocity</span>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-white/45">
            Concierge-level luxury and exotic vehicle rentals in Miami, Florida. Airport delivery, premium service, and one of Miami's finest fleets.
          </p>
          <p className="font-display mt-6 text-lg italic text-gold">Drive Beyond Ordinary.</p>
        </div>

        <div className="md:col-span-3">
          <span className="text-[10px] font-medium uppercase tracking-[0.3em] text-white/40">Explore</span>
          <ul className="mt-5 space-y-3">
            {LINKS.map((l) => (
              <li key={l.label}>
                <button data-testid={`footer-link-${l.label.toLowerCase()}`} onClick={() => onNavigate(l.href)} className="text-sm font-light text-white/60 transition-colors duration-300 hover:text-gold">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <span className="text-[10px] font-medium uppercase tracking-[0.3em] text-white/40">Contact</span>
          <ul className="mt-5 space-y-4 text-sm font-light text-white/60">
            <li>
              <a data-testid="footer-phone" href={PHONE_HREF} className="flex items-center gap-3 transition-colors hover:text-gold">
                <Phone className="h-4 w-4 text-gold" /> {PHONE}
              </a>
            </li>
            <li>
              <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 transition-colors hover:text-gold">
                <Mail className="h-4 w-4 text-gold" /> {EMAIL}
              </a>
            </li>
            <li>
              <a data-testid="footer-instagram" href={INSTAGRAM_HREF} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Instagram className="h-4 w-4 text-gold" /> {INSTAGRAM}
              </a>
            </li>
          </ul>
          <div className="mt-6 border-t border-white/10 pt-5 text-sm text-white/50">
            <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">Business Hours</span>
            <p data-testid="footer-hours" className="mt-2">Monday – Sunday · 8:00 AM – 10:00 PM</p>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 text-xs font-light text-white/35 md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} ALAS Velocity · Miami, Florida</span>
        <span className="uppercase tracking-[0.3em]">Drive Beyond Ordinary</span>
        <a data-testid="footer-admin-link" href="/admin" className="text-white/25 transition-colors duration-300 hover:text-gold">Admin</a>
      </div>
    </div>
  </footer>
);

export default Footer;
